const Mega = (el) => {
    const parent = el.closest('li');
    const list = parent.closest('ul');

    // Get position of list relative to viewport to find where the mega menu should be placed
    const listRect = list.getBoundingClientRect();
    const megaLeftPos = listRect.left + 16;

    // Get current position of element relative to viewport for changing the position to a fixed one
    const parentRect = parent.getBoundingClientRect();
    const left = megaLeftPos - parentRect.left;
    el.style.left =`${left}px`;
};

export default Mega;
